import React, { useContext, useEffect } from "react";
import { titleFromParams } from "../../Utilities/helperFunction";
import appContext from "../../appContext";
import "./style.scss";

const FacebookLogin = ({
  mock,
  index,
  setValue,
  setMaintainValues,
  maintainValues,
}) => {
  const { setCustomStyles, facebookDetails } = useContext(appContext);

  useEffect(() => {
    setCustomStyles(mock?.styles || {});
  }, []);

  useEffect(() => {
    if (Object.keys(facebookDetails || {}).length) {
      setValue(mock?.name, facebookDetails);
      setMaintainValues({
        ...maintainValues,
        [`${mock?.name}`]: facebookDetails,
      });
    }
  }, [facebookDetails]);

  return (
    <div className="facebook-container">
      <div className="facebook-title">
        <h1 className="title">
          <span>
            {index}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="10"
              viewBox="0 0 24 24"
            >
              <path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z" />
            </svg>
          </span>
          <div
            dangerouslySetInnerHTML={{ __html: titleFromParams(mock?.title) }}
          />
        </h1>
        <div
          className="description-container"
          dangerouslySetInnerHTML={{ __html: mock?.description }}
        />
      </div>
      <iframe
        title="Executive summary Google Login"
        frameborder="0"
        height="50px"
        src={`${process.env.REACT_APP_FACEBOOK_LOGIN_URL}?status=update&isBackground=false`}
      ></iframe>
    </div>
  );
};

export default FacebookLogin;
